import { render, staticRenderFns } from "./DemoAccount.vue?vue&type=template&id=03e74f11"
import script from "./DemoAccount.vue?vue&type=script&lang=js"
export * from "./DemoAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports